import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import FleetWebApi from "../Api/FleetWebApi";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

function DecryptData(props) {
  const [coreID, setCoreID] = useState("");
  const [payload, setPayload] = useState("");
  const [jsonPayload, setJsonPayload] = useState("");
  const [encryptedData, setEncryptedData] = useState("");
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = () => {
    setResponse(null);
    setError(null);
    if (coreID.length !== 24) {
      setError("Invalid CoreID");
    } else if (encryptedData.length === 0 && payload.length === 0) {
      setError("Payload cannot be empty");
    } else {
      console.log(coreID, encryptedData.length > 0 ? encryptedData : payload);
      FleetWebApi.decryptData(
        coreID,
        encryptedData.length > 0 ? encryptedData : payload
      ).then(
        (result) => {
          try {
            setResponse(JSON.stringify(JSON.parse(result.response), null, 2));
          } catch (err) {
            setResponse(
              "Response: " + result.response + "\n JSON error: " + err
            );
          }
        },
        (error) => {
          console.log(error);
          setError(error);
        }
      );
    }
  };
  const handleInputChange = (e) => {
    setPayload(e.target.value);
    try {
      const jsonObject = JSON.parse(e.target.value); // this line will throw an error if the json is invalid
      setJsonPayload(JSON.stringify(jsonObject, null, 2)); // prettify the json
      if ("id" in jsonObject && jsonObject["id"].length === 24) {
        setCoreID(jsonObject["id"]);
      }
      if ("msg" in jsonObject) {
        setEncryptedData(jsonObject["msg"].replace("radio_rx  ", ""));
      } else {
        setEncryptedData("");
      }
    } catch (error) {
      setEncryptedData("");
      setJsonPayload(e.target.value);
    }
  };
  return (
    <Container>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <h1>Decoder Ring</h1>
        </Grid>
      </Grid>
      <br />
      <br />
      <Grid container spacing={3} justifyContent={"space-between"}>
        <Grid item xs={12} sm={12} md={5.5} lg={5.5} xl={5.5}>
          <Grid container spacing={1} justifyContent={"space-between"}>
            <Grid item xs={10} sm={10} md={8} lg={8} xl={8}>
              <TextField
                id="coreIDinput"
                label={"Core ID"}
                minRows={1}
                maxRows={1}
                variant="outlined"
                fullWidth
                color="info"
                value={coreID}
                onChange={(event) => setCoreID(event.target.value)}
              />
            </Grid>
            <Grid item xs={10} sm={10} md={3} lg={3} xl={3}>
              <Button
                variant="contained"
                type="test"
                color="primary"
                label="Add Note"
                fullWidth
                size="large"
                style={{ marginTop: 5 }}
                onClick={handleSubmit}
              >
                Decrypt
              </Button>
            </Grid>
          </Grid>
          <br />
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextField
              id="payloadinput"
              label={"Payload"}
              minRows={15}
              maxRows={20}
              multiline
              variant="outlined"
              fullWidth
              color="info"
              // value={responses}
              onChange={handleInputChange}
              value={jsonPayload}
            />
          </Grid>
        </Grid>
        {/* Second column */}

        <Grid item xs={12} sm={12} md={5.5} lg={5.5} xl={5.5}>
          <TextField
            id="Response"
            label={"Response"}
            multiline
            minRows={18}
            maxRows={20}
            variant="outlined"
            fullWidth
            color="info"
            disabled={true}
            autoFocus={true}
            value={error ? error : response ? response : ""}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default DecryptData;
